import React from "react";
import {
  MASTERY_MAX,
  MIX_KEY,
  keyLabel,
  drillKind,
  fmtMs,
  TIMER_UNLOCK_PERFECTS,
} from "../../lib/numberSenseV2";
import { Icon } from "../numberSenseUi";

/* ============================================================
   Number Sense v2 — end-of-drill screen. `info` from finishDrill:
     pass → { passed:true, practice, award, acc, hearts, levelUps,
              runs, newBest }
     fail → { passed:false, correct, total }   (mixed sets only —
              practice runs always finish)
   plus { type, keyName, drillKindId } for labels and actions.
   ============================================================ */

const DoneScreen = ({
  info,
  type,
  keyName,
  drillKindId,
  onHome,
  onAgain,
  onPickKey,
}) => {
  const where = keyName === MIX_KEY ? "mixed keys" : keyLabel(type, keyName);
  const kind = drillKind(drillKindId);
  const kindTitle = kind ? kind.title : "drill";

  if (info.passed) {
    return (
      <div className="ns-root">
        <div className="ns-app">
          <div className="done-screen">
            <div className="trophy">
              <Icon name="trophy" />
            </div>
            <div className="big">{info.practice ? "run done!" : "drill down!"}</div>
            <div className="sub">
              {kindTitle} · {where}
              {info.practice && info.runs > 1 ? ` — run ${info.runs}` : ""}
            </div>
            {info.practice && info.newBest && !info.timed && (
              <div className="v2-best-chip">
                <Icon name="bolt" /> new best!
              </div>
            )}
            {info.newBestTime && (
              <div className="v2-best-chip">
                <Icon name="bolt" /> fastest clean run yet!
              </div>
            )}
            {info.newBestStreak && (
              <div className="v2-best-chip v2-streak-best">
                <Icon name="flame" /> longest streak yet — {info.answerStreak.best}{" "}
                in a row
              </div>
            )}
            <div className="scorecards">
              <div className="scorecard sc-xp">
                <div className="k">XP earned</div>
                <div className="v">+{info.award}</div>
              </div>
              <div className="scorecard sc-acc">
                <div className="k">accuracy</div>
                <div className="v">{info.acc}%</div>
              </div>
              {info.timed && (
                <div className="scorecard">
                  <div className="k">time</div>
                  <div className="v mono">{fmtMs(info.totalMs)}</div>
                </div>
              )}
              {!info.practice && (
                <div className="scorecard">
                  <div className="k">hearts</div>
                  <div className="v" style={{ color: "var(--red)" }}>
                    {info.hearts}
                  </div>
                </div>
              )}
              {info.answerStreak && info.answerStreak.current >= 3 && (
                <div className="scorecard">
                  <div className="k">in a row</div>
                  <div className="v">{info.answerStreak.current}</div>
                </div>
              )}
            </div>
            {info.timerJustUnlocked && (
              <div className="v2-unlock-note">
                <Icon name="timer" /> {TIMER_UNLOCK_PERFECTS} clean runs — the
                timer's on next time. chase your best clean time.
              </div>
            )}
            {info.levelUps.length > 0 && (
              <div className="v2-levelups">
                {info.levelUps.map((l) => (
                  <div className="v2-levelup" key={l.keyName}>
                    {l.crowned ? (
                      <>
                        <Icon name="trophy" /> <b>{keyLabel(type, l.keyName)}</b>{" "}
                        crowned!
                      </>
                    ) : (
                      <>
                        <b>{keyLabel(type, l.keyName)}</b> → level {l.level}/
                        {MASTERY_MAX}
                      </>
                    )}
                  </div>
                ))}
              </div>
            )}
            <button className="btn" style={{ maxWidth: 320 }} onClick={onAgain}>
              {info.practice ? "Run it again" : "Drill again"}
            </button>
            <button
              className="btn ghost"
              style={{ maxWidth: 320, marginTop: 12 }}
              onClick={onPickKey}
            >
              Other drills
            </button>
            <button
              className="btn ghost"
              style={{ maxWidth: 320, marginTop: 12 }}
              onClick={onHome}
            >
              Back to scales
            </button>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="ns-root">
      <div className="ns-app">
        <div className="done-screen">
          <div className="fail-mark" style={{ color: "var(--red)" }}>
            <Icon name="heartbreak" />
          </div>
          <div className="big">out of hearts</div>
          <div className="sub">
            {where} bites back — another run and it's yours.
          </div>
          <div className="scorecards">
            <div className="scorecard sc-acc">
              <div className="k">got right</div>
              <div className="v">
                {info.correct}/{info.total}
              </div>
            </div>
          </div>
          <button
            className="btn loje"
            style={{ maxWidth: 320, marginBottom: 12 }}
            onClick={onAgain}
          >
            Try again
          </button>
          <button className="btn ghost" style={{ maxWidth: 320 }} onClick={onHome}>
            Back to scales
          </button>
        </div>
      </div>
    </div>
  );
};

export default DoneScreen;
